import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardWidgetContent, DashboardWidgetLookup } from '@serengeti/serengeti-dashboard';

@DashboardWidgetLookup('WizardTestBedComponent')
@Component({
  selector: 'app-wizard-test-bed',
  templateUrl: './wizard-test-bed.component.html',
  styleUrls: ['./wizard-test-bed.component.scss']
})
export class WizardTestBedComponent implements OnInit, DashboardWidgetContent {

  constructor(
    private router: Router
  ) { }

  property(): boolean {
    return true;
  }

  configure(setting: any): void {
  }

  ngOnInit() {
  }

  public goTestbed() {
    this.router.navigate(['/main', {outlets: {content: 'order/form/view/311c57d7-394e-42b8-bee3-ede610d3910d/'}}]);
  }

}
